import { ImgBlankProfile } from "../../../assets/images";

export default function SearchedCustomerProfile({ data, children }) {
  const { profile, address } = data ?? {};
  return (
    <div className="border rounded p-3 mb-3">
      <div className="row gap-3">
        <div className="col-12 col-md-auto text-center text-md-start">
          <img
            className="rounded"
            style={{ height: 100, width: 100 }}
            src={ImgBlankProfile}
            alt="Profile"
          />
        </div>
        <div className="col">
          <ul className="list-unstyled mb-0">
            <li>
              <b>ID:</b> {profile?.customer_id ?? ""}
            </li>
            <li>
              <b>Name:</b> {profile?.name ?? ""}
            </li>
            <li>
              <b>Mobile:</b> {profile?.mobile ?? ""}
            </li>
            <li>
              <b>Gender:</b> {profile?.gender_name ?? ""}
            </li>
            <li>
              <b>Address:</b> {address}
            </li>
          </ul>
        </div>
        {children}
      </div>
    </div>
  );
}
